export function getContractsOverviewEndpoint(): string {
    return '/contracts';
}
export function getFinancialDetailsEndpoint(contractId: string): string {
    return `${getContractsOverviewEndpoint()}/${contractId}/financialDetails/`;
}

export function getVehicleDetailsEndpoint(contractId: string): string {
    return `${getContractsOverviewEndpoint()}/${contractId}/vehicles`;
}
export function getInsuranceDetailsEndpoint(serialNumber: string): string {
    return `${getContractsOverviewEndpoint()}/insurance/${serialNumber}`;
}
export function getPolicyCoverEndpoint(policyId: string): string {
    return `${getContractsOverviewEndpoint()}/insurance/policy-cover/${policyId}`;
}
export function getAdditionalServicesDetails(): string {
    return `${getContractsOverviewEndpoint()}/additional-services`;
}
export function getAdditionalServicesCertificate(certificateId: string): string {
    return `${getContractsOverviewEndpoint()}/additional-services/certificate/${certificateId}`;
}
